module.exports = __webpack_public_path__ + "media/03.e248e268.wav";